var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"lg:hidden lg:group-hover:block h-6 w-6 bg-black p-1 text-white rounded text-sm z-100",attrs:{"name":"to-cart","type":"submit"},on:{"click":_vm.addItemToCart}},[_c('i',{staticClass:"fal fa-cart-plus"})])}
var staticRenderFns = []

export { render, staticRenderFns }